/**
 * Maps Salesforce Rich Text Image refids to static assets under /assets/images/knowledge/.
 * Generated by: node apps/urban/scripts/extract-knowledge-images.mjs
 */
const KNOWLEDGE_IMAGE_BASE = '/assets/images/knowledge';

/** refid → filename (without path) */
export const RTA_IMAGE_MAP: Record<string, string> = {
  '0EM3z000001pQ7J': '0EM3z000001pQ7J.gif',
  '0EM3z000001pQIC': '0EM3z000001pQIC.gif',
  '0EM3z000001pUN6': '0EM3z000001pUN6.png',
  '0EM3z000001pVPI': '0EM3z000001pVPI.png',
  '0EM3z000001pWvK': '0EM3z000001pWvK.gif',
  '0EM3z000001pXJ8': '0EM3z000001pXJ8.gif',
  '0EM3z000001snoA': '0EM3z000001snoA.png',
  '0EM3z0000029a5k': '0EM3z0000029a5k.png',
  '0EM3z000002LRzV': '0EM3z000002LRzV.png',
  '0EM3z000002LWlJ': '0EM3z000002LWlJ.png',
  '0EM3z000002LYCz': '0EM3z000002LYCz.png',
  '0EM3z000002LYHk': '0EM3z000002LYHk.png',
  '0EM3z000002LYHp': '0EM3z000002LYHp.png',
  '0EM3z000002LYId': '0EM3z000002LYId.png',
  '0EM3z000002LYIi': '0EM3z000002LYIi.png',
  '0EM3z000002LYJC': '0EM3z000002LYJC.png',
  '0EM3z000002LYJH': '0EM3z000002LYJH.png',
  '0EM3z000002LYJM': '0EM3z000002LYJM.png',
  '0EM3z000002LYJR': '0EM3z000002LYJR.png',
  '0EM3z000002LYok': '0EM3z000002LYok.png',
  '0EM3z000002LYuS': '0EM3z000002LYuS.png',
  '0EM3z000002LZzT': '0EM3z000002LZzT.png',
  '0EM3z000002hLJN': '0EM3z000002hLJN.png',
  '0EM3z000002hLRq': '0EM3z000002hLRq.png',
  '0EM3z000002hLat': '0EM3z000002hLat.png',
  '0EM3z000002hLiI': '0EM3z000002hLiI.png',
  '0EM3z000002hNhl': '0EM3z000002hNhl.png',
  '0EM3z0000036YAD': '0EM3z0000036YAD.png',
  '0EM3z000003UT6N': '0EM3z000003UT6N.png',
  '0EM3z000003UT6X': '0EM3z000003UT6X.png',
  '0EM3z000003Utfz': '0EM3z000003Utfz.png',
  '0EM3z000003Utg4': '0EM3z000003Utg4.png',
  '0EM3z000003VUYw': '0EM3z000003VUYw.png',
  '0EM3z000003VUho': '0EM3z000003VUho.png',
  '0EM3z000004LHVn': '0EM3z000004LHVn.gif',
  '0EM3z000004LTka': '0EM3z000004LTka.png',
  '0EM3z000004Lc6o': '0EM3z000004Lc6o.png',
  '0EM3z000004LfPj': '0EM3z000004LfPj.png',
  '0EM3z000004MQGX': '0EM3z000004MQGX.png',
  '0EM3z000004MQIY': '0EM3z000004MQIY.png',
  '0EMSl000005ZSD3': '0EMSl000005ZSD3.png',
  '0EMSl000006g2GV': '0EMSl000006g2GV.png',
  '0EMSl000006m2Tv': '0EMSl000006m2Tv.png',
  '0EMSl00000AdWiE': '0EMSl00000AdWiE.png',
  '0EMSl00000AdXfu': '0EMSl00000AdXfu.png',
  '0EMSl00000C94Or': '0EMSl00000C94Or.png',
  '0EMSl00000GcYAl': '0EMSl00000GcYAl.png',
  '0EMSl00000GcaKf': '0EMSl00000GcaKf.png',
  '0EMSl00000GcdIU': '0EMSl00000GcdIU.png',
  '0EMSl00000Gceb8': '0EMSl00000Gceb8.png',
  '0EMSl00000GciV4': '0EMSl00000GciV4.png',
  '0EMSl00000GcibW': '0EMSl00000GcibW.png',
  '0EMSl00000GcilB': '0EMSl00000GcilB.png',
  '0EMSl00000Gciq1': '0EMSl00000Gciq1.png',
  '0EMSl00000HSACO': '0EMSl00000HSACO.png',
  '0EMSl00000HSLR8': '0EMSl00000HSLR8.png',
  '0EMSl00000HSLXZ': '0EMSl00000HSLXZ.png',
  '0EMSl00000HSLcP': '0EMSl00000HSLcP.png',
  '0EMSl00000HSLir': '0EMSl00000HSLir.png',
  '0EMSl00000Hpq1C': '0EMSl00000Hpq1C.png',
  '0EMSl00000HqG0X': '0EMSl00000HqG0X.png',
  '0EMSl00000HqJ3D': '0EMSl00000HqJ3D.png',
};

export function resolveRtaImageSrc(refid: string): string | undefined {
  const file = RTA_IMAGE_MAP[refid];
  return file ? `${KNOWLEDGE_IMAGE_BASE}/${file}` : undefined;
}
